<template>
  <div class="download">
    <div class="pos t0 header-box zi1">
      <header-df class="user-header g-center" no-tabs-active></header-df>
    </div>
    <offline></offline>
    <div class="content-box por zi0">
      <div class="g-center">
        <div class="app-list flex aic">
          <div class="ctrl-width">
            <i class="curr-ico left flex csp" @click="curr--" v-show="curr > 1"></i>
          </div>
          <div class="app-list-inner flex-1 ovh flex unselect">
            <template v-for="(app, i) in currAppList">
              <div @mouseenter="aid = app.product_id" class="app-box" :class="{active: +aid === app.product_id}"
                   :key="i"
                   :style="{marginLeft: (curr - 1) * !i * 176 * -6  + 'px'}">
                <div class="app por flex jcc aic">
                  <div class="poa curr-ico hot img zi1" v-show="hot === app.product_id"></div>
                  <div class="app-inner flex-col aic jcc lh1">
                    <img v-df-avatar :src="app.icon" alt="" class="app-logo vat"/>
                    <span class="app-name">{{app.name}}</span>
                  </div>
                </div>
                <div class="arrow mlr-auto"></div>
              </div>
            </template>
          </div>
          <div class="ctrl-width">
            <i class="curr-ico right flex csp" @click="curr++" v-show="showNext"></i>
          </div>
        </div>
        <div class="app-detail" v-if="currApp" :key="currApp && currApp.id">
          <div class="move">
            <div class="title flex aic"><i class="curr-ico phone"></i>{{currApp.name}} - 手机 / 平板端</div>
            <div class="detail-inner flex">
              <div class="detail-left flex-1">
                <div class="remark wspl">{{currApp.remark}}</div>
                <div class="download-box flex">
                  <div class="buttons tac flex-col">
                    <a class="android" target="_blank" download="" :href="currApp.fileurl"><i
                            class="curr-ico android"></i>安卓下载</a>
                    <a class="ios" target="_blank" :href="currApp.iosLink"><i class="curr-ico ios"></i>IOS下载</a>
                  </div>
                  <div class="qr-code lh1" v-show="currApp.qrcode">
                    <img :src="currApp.qrcode" alt="" class="qr-code-inner"/>
                    <div class="">扫二维码下载即刻体验</div>
                  </div>
                </div>
              </div>
              <div class="detail-right">
                <download-carousel v-model="currApp.currCarousel" :list="currApp.cuts"></download-carousel>
              </div>
            </div>
          </div>
          <div class="tv" v-show="currApp.hasTv">
            <div class="title flex aic"><i class="curr-ico tv"></i>{{currApp.name}} - 电视端</div>
            <div class="detail-inner flex">
              <div class="detail-left flex-1">
                <div class="remark wspl">{{currApp.tvRemark}}</div>
                <div class="install wspl"><span class="bold">安装方式1：</span>可在各大品牌应用商店（沙发管家，天猫魔盒，蜜蜂TV，当贝市场）搜索“{{currApp.name}}”下载安装

                  <span class="bold">安装方式2：</span>点击下方“立即下载”按钮，将“{{currApp.name}}”apk文件下载至U盘，再将U盘插入电视机或机顶盒中即可安装应用
                </div>
                <div class="buttons tac flex-col">
                  <a class="tv-btn" target="_blank" download="" :href="currApp.tv"><i class="curr-ico install"></i>立即下载</a>
                </div>
              </div>
              <div class="detail-right">
                <download-carousel v-model="currApp.tvCurrCarousel" :list="currApp.tvCuts"></download-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-bottom class="footer"></footer-bottom>
  </div>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex';
  import Mixins from '../mixins/mixins';
  import DownloadCarousel from '../components/download/carousel';

  export default {
    name: "Download",
    mixins: [Mixins.MakeRoute(['aid'], 'query', 'replace')],
    components: {
      DownloadCarousel,
    },
    computed: {
      ...mapGetters(['userInfo', 'allGrades', 'currTab']),
      showNext() {
        return this.curr < Math.ceil(this.appList.length / 6);
      },
      currAppList() {
        return this.appList.filter(e => e.name);
      },
      currApp() {
        return this.currAppList.find(e => e.product_id === +this.aid);
      },
      hot() {
        let all = this.allGrades || [];
        return !!this.userInfo.is_web_vip || (13 ** !all.find(grade => +grade.pid === 2 && grade.id === this.userInfo.nianji_id));
      },
    },
    data() {
      return {
        curr: 1,
        appList: [],
        iosLinkList: [
          {
            name: '格灵课堂',
            qrcode: require('../assets/images/qrcode/glkt.png'),
            iosLink: 'https://apps.apple.com/cn/app/%E6%A0%BC%E7%81%B5%E8%AF%BE%E5%A0%82/id1515215924'
          },
          {
            name: '中小学辅导班',
            qrcode: require('../assets/images/qrcode/zxxfdb.png'),
            iosLink: 'https://apps.apple.com/cn/app/%E4%B8%AD%E5%B0%8F%E5%AD%A6%E8%BE%85%E5%AF%BC%E7%8F%AD/id1532368974'
          },
          {
            name: '同步小学课堂',
            qrcode: require('../assets/images/qrcode/tbxxkt.png'),
            iosLink: 'https://apps.apple.com/cn/app/%E5%90%8C%E6%AD%A5%E5%B0%8F%E5%AD%A6%E8%AF%BE%E5%A0%82/id1489547878'
          },
          {
            name: '小学同步一年级',
            qrcode: require('../assets/images/qrcode/xxtb1.png'),
            iosLink: 'https://apps.apple.com/cn/app/%E5%B0%8F%E5%AD%A6%E5%90%8C%E6%AD%A5%E4%B8%80%E5%B9%B4%E7%BA%A7/id1557843721'
          },
          {
            name: '小学同步二年级',
            qrcode: require('../assets/images/qrcode/xxtb2.png'),
            iosLink: 'https://apps.apple.com/cn/app/%E5%B0%8F%E5%AD%A6%E5%90%8C%E6%AD%A5%E4%BA%8C%E5%B9%B4%E7%BA%A7/id1558020978'
          },
          {
            name: '小学同步三年级',
            qrcode: require('../assets/images/qrcode/xxtb3.png'),
            iosLink: 'https://apps.apple.com/cn/app/%E5%B0%8F%E5%AD%A6%E5%90%8C%E6%AD%A5%E4%B8%89%E5%B9%B4%E7%BA%A7/id1558022585'
          },
          {
            name: '小学同步四年级',
            qrcode: require('../assets/images/qrcode/xxtb4.png'),
            iosLink: 'https://apps.apple.com/cn/app/%E5%B0%8F%E5%AD%A6%E5%90%8C%E6%AD%A5%E4%B8%89%E5%B9%B4%E7%BA%A7/id1558022585'
          },
          {
            name: '小学同步五年级',
            qrcode: require('../assets/images/qrcode/xxtb5.png'),
            iosLink: 'https://apps.apple.com/cn/app/%E5%B0%8F%E5%AD%A6%E5%90%8C%E6%AD%A5%E4%BA%94%E5%B9%B4%E7%BA%A7/id1558053022'
          },
          {
            name: '小学同步六年级',
            qrcode: require('../assets/images/qrcode/xxtb6.png'),
            iosLink: 'https://apps.apple.com/cn/app/%E5%B0%8F%E5%AD%A6%E5%90%8C%E6%AD%A5%E5%85%AD%E5%B9%B4%E7%BA%A7/id1558054444'
          },
          {
            name: '同步小学微课',
            qrcode: '',
            iosLink: 'https://apps.apple.com/cn/app/%E5%90%8C%E6%AD%A5%E5%B0%8F%E5%AD%A6%E5%BE%AE%E8%AF%BE/id1574644251'
          },
          {
            name: '小学科学奥数',
            qrcode: '',
            iosLink: 'https://apps.apple.com/cn/app/%E5%B0%8F%E5%AD%A6%E7%A7%91%E5%AD%A6%E5%A5%A5%E6%95%B0/id1570748869'
          },
          {
            name: '幼儿早教',
            qrcode: require('../assets/images/qrcode/yezj.png'),
            iosLink: 'https://apps.apple.com/cn/app/%E5%B9%BC%E5%84%BF%E6%97%A9%E6%95%99-%E5%84%BF%E6%AD%8C%E6%95%85%E4%BA%8B%E7%94%BB%E7%94%BB%E8%8B%B1%E8%AF%AD%E5%90%AF%E8%92%99%E4%BA%B2%E5%AD%90%E4%BA%92%E5%8A%A8/id1562091596'
          },
          {
            name: '国学大王',
            qrcode: require('../assets/images/qrcode/gxdw.png'),
            iosLink: 'https://apps.apple.com/cn/app/%E5%9B%BD%E5%AD%A6%E5%A4%A7%E7%8E%8B/id1566811901'
          },
          {
            name: '儿童故事城堡',
            qrcode: '',
            iosLink: 'https://apps.apple.com/cn/app/%E5%84%BF%E7%AB%A5%E6%95%85%E4%BA%8B%E5%9F%8E%E5%A0%A1/id1567344692'
          }
        ],
      };
    },
    watch: {
      currAppList() {
        if (!this.currAppList.find(e => e.product_id === +this.aid) && this.currAppList.length) {
          this.aid = this.currAppList[0].product_id;
        }
      },
    },
    created() {
      this.getList();
    },
    methods: {
      ...mapMutations(['setCurrTab']),
      getList() {
        this.http.NEWMyVip({
          // 未登录时用一个不存在的用户 必填项
          uid: this.userInfo.uid || 'a',
          terminal_id: '3,4',
          channel_id: 129,
          is_https: +(location.protocol === 'https:'),
        }).then(res => {
          let phone = res.list.filter(app => +app.terminal_id === 3);
          let tv = res.list.filter(app => +app.terminal_id === 4);
          phone.forEach(app => {
            let currTv = tv.find(a => a.product_id === app.product_id) || {};
            let iosLink = this.iosLinkList.find(ios => ios.name === app.name);
            if (iosLink) {
              app.qrcode = iosLink.qrcode;
              app.iosLink = iosLink.iosLink;
            }

            app.hasTv = !!currTv.id;
            app.tv = currTv.fileurl;
            app.tvRemark = currTv.remark;

            app.cuts = [];
            app.currCarousel = 0;
            app.tvCuts = [];
            app.tvCurrCarousel = 0;
            for (let i = 1; i <= 5; i++) {
              let url = app['screenshot' + i];
              let tvUrl = currTv['screenshot' + i];
              url && app.cuts.push(url);
              tvUrl && app.tvCuts.push(tvUrl);
            }
          });
          this.appList = phone;
        }).catch(console.log);
      },
    },
  }
</script>

<style scoped lang="less">
  @import "../assets/less/function";

  .bold {
    font-size: 16px;
    color: #333f4e;

  }

  .curr-ico {
    &.img {
      .spirit(url(../assets/images/download_icon.png));
    }
    &:not(.img) {
      .spirit-mask(url(../assets/images/download_icon.png));
    }
    &.left {
      &:after {
        width: 36px;
        height: 56px;
        mask-position: -2px -2px;
        background-color: #666f7a;
      }
    }
    &.hot {
      &:after {
        width: 34.7px;
        height: 34.7px;
        background-position: -205.8px -4.1px;
      }
    }
    &.right {
      &:after {
        width: 36px;
        height: 56px;
        mask-position: -40px -2px;
        background-color: #666f7a;
      }
    }

    &.phone {
      &:after {
        mask-position: -80px -31px;
      }
    }
    &.tv {
      &:after {
        mask-position: -103px -31px;
      }
    }
    &.android {
      &:after {
        mask-position: -169px -2px;
      }
    }
    &.ios {
      &:after {
        mask-position: -143px -2px;
      }
    }
    &.install {
      &:after {
        mask-position: -117px -2px;
      }
    }
  }

  .header-box {
    background-color: #fff;
  }

  .content-box {
    padding: 74px 0 72px;
    min-height: 500px;
    background: linear-gradient(180deg, #C2DCFE, #F5FCFF 500px, #f5fcff 100%) no-repeat top left / 100% 100%;
    // background: linear-gradient(180deg, #C2DCFE, #F5FCFF 500px, #f5fcff 100%) fixed no-repeat top left / 100% 100%;
  }

  .app-list {
    margin-bottom: 4px;
    padding: 0 22px;
    &-inner {
      margin: 0 20px;
    }
    .ctrl-width {
      width: 36px;
    }
    .app-box {
      margin-right: 16px;
      flex: none;
      transition: margin-left .3s;
    }
    .app {
      width: 160px;
      height: 160px;
      font-size: 14px;
      color: #999fa6;
      background-color: transparent;
      border-radius: 8px;
      transition: background-color .3s;
    }
    .app-logo {
      margin-bottom: 14px;
      width: 84px;
      height: 84px;
      border: 1px solid transparent;
    }
    .arrow {
      width: 0;
      height: 0;
      border-top: 18px solid transparent;
      border-left: 16.5px solid transparent;
      border-right: 16.5px solid transparent;
      transition: border-color .3s;
    }
    .hot {
      top: 6px;
      left: 33px;
    }
    .active {
      .app-inner {
        transform: scale(1.142);
      }
      .hot {
        top: 0;
        left: 27px;
      }
      .app {
        background-color: #fff;
      }
      .app-name {
        color: #333f4e;
      }
      .arrow {
        border-top-color: #fff;
      }
      .app-logo {
        border-color: #e1eeff;
        border-radius: 18px;
      }
    }
  }

  .app-detail {
    padding: 32px;
    font-size: 14px;
    color: #666F7A;
    line-height: 22px;
    background: #fff;
    border-radius: 8px;
    > :not(:first-child) {
      margin-top: 107px;
    }
  }

  .title {
    margin-bottom: 23px;
    font-size: 20px;
    line-height: 1;
    color: #2f2f2f;
    .curr-ico {
      margin-right: 15px;
      &:after {
        width: 20px;
        height: 20px;
        background-color: #626262;
      }
    }
  }

  .remark {
    margin-bottom: 38px;
  }

  .tv {
    .remark {
      margin-bottom: 44px;
      + .install {
        margin-bottom: 38px;
      }
    }
  }

  .buttons {
    > :nth-child(n) {
      width: 214px;
      color: #fff;
      font-size: 16px;
      line-height: 40px;
      background-color: #1177ff;
      border-radius: 40px;
      cursor: pointer;
      text-decoration-line: none;
      &:hover {
        background-color: #0066ed;
      }
    }
    > :not(:last-child) {
      margin-bottom: 24px;
    }
    .curr-ico {
      margin-right: 16px;
      &:after {
        width: 24px;
        height: 24px;
        background-color: #fff;
      }
    }
  }

  .move {
    .buttons {
      margin-top: 18px;
    }
  }

  .qr-code {
    margin-left: 72px;
    font-size: 14px;
    color: #999fa6;
    &-inner {
      margin-bottom: 17px;
      width: 142px;
      height: 142px;
    }
  }

  .detail-right {
    margin-left: 38px;
  }


</style>